export default __webpack_public_path__ + "static/media/FSF.dd1b7ce7.webp";